var sizeCheck = 0;

jQuery( document ).ready(function() {

    body = jQuery("body");

    body.on("click", ".parent_arrow", function(){
        jQuery(this).parent(".nav_block").toggleClass("showDropdown");
    });
    body.on("click touch", ".burger_menu", function(){
        if(body.hasClass("showMobileMenu")){
            body.toggleClass("showMobileMenu no-scroll");
            jQuery(".navigation_wrapper").css("maxHeight", 0);
        }else{
            body.toggleClass("showMobileMenu no-scroll");
            heightvalue = jQuery(window).innerHeight() - jQuery("#shopify-section-site-header").height() - jQuery("#shopify-section-announcements").height();
            jQuery(".navigation_wrapper").css("maxHeight", heightvalue);
        }
    });

  if(jQuery(".mobile_slider_wraper").length){
    jQuery(".mobile_slider_wraper").slick();
  }

});

/**
 * Apply scrolling class to header when scrolling down
 */
(function ($) {

  $(window).bind('mousewheel', function (e) {

    if ($(e.target).parents('.select2-results').length > 0) return;

    if (e.originalEvent.wheelDelta >= 0) { // if scrolling up
      $('.site-header').removeClass('scrolling');
    } else {
      if (jQuery(document).scrollTop() > 84) { // if past height of header
        $('.site-header').addClass('scrolling');
      }
    }

  });

})(jQuery);

/**
 * Control the multistore selector in the header
 */
(function ($) {

  /**
   * Keep track of if we have duplicated the selector to prevent an infinite loop
   */
  var updated = false;

  /**
   * Keep track of if the dropdown is open on mobile, so we can give better clicking functionality
   */
  var isMobileOpen = false;

  /**
   * Constants
   */
  var navigationMobileBreakpoint = 1024;
  var optionsSchema = [
    {
      title: 'United Kingdom',
      countries: ['GB']
    },
    {
      title: 'United States',
      countries: ['US']
    },
    {
      title: 'Canada',
      countries: ['CA']
    },
    {
      title: 'Australia',
      countries: ['AU']
    },
    {
      title: 'Europe',
      countries: ['AX', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'AL', 'AD', 'AM', 'BY', 'BA', 'FO', 'GE', 'GI', 'IS', 'IM', 'XK', 'LI', 'MK', 'MD', 'MC', 'ME', 'NO', 'SM', 'RS', 'CH', 'TR', 'UA', 'VA', 'GL', 'GP', 'GG', 'JE', 'YT', 'RE', 'SJ']
    },
    {
      title: 'International',
      countries: '*'
    }
  ];

  /**
   * URLs
   */
  var flag = function (x) { return ('https://cdn.shopify.com/static/images/flags/' + x + '.svg').toLowerCase(); };

  /**
   * Classes
   */
  var oldSelectorContainerClass = 'locale-selectors__container';
  var newSelectorContainerClass = 'header-locale-selectors__container';

  /**
   * Selectors
   */
  var oldSelectorContainer = '.' + oldSelectorContainerClass;
  var newSelectorContainer = '.' + newSelectorContainerClass;
  var newHeaderPosition    = '.site-header__top__right';
  var selectInput          = '.locale-selectors__selector';
  var oldSelectorForm      = oldSelectorContainer + ' form';
  var oldSelectInput       = oldSelectorContainer + ' ' + selectInput;
  var newSelectInput       = newSelectorContainer + ' ' + selectInput;
  var oldSelectOptions     = oldSelectInput + ' option';
  var newSelectOptions     = newSelectInput + ' option';
  var newSelectListItem    = '.select2-container .select2-results__option[role="option"]';
  var newSelectInputEl     = '.select2-dropdown .select2-search__field';
  var oldActiveOption      = oldSelectOptions + ':selected';
  var newActiveOption      = newSelectorContainer + ' .select2-selection__rendered';
  var newSelectOptGroups   = function (x) { return newSelectInput + ' optgroup[label="' + x + '"]'; };
  var mobileNavWrapper     = '.navigation_wrapper > .wrapper';
  var mobileOuterClick     = mobileNavWrapper + ' .header-locale-selectors__container';

  /**
   * Allow support for clicking the entire row on mobile
   */
  var handleClick = function () {
    if ($(window).width() > navigationMobileBreakpoint) return;
    $(mobileOuterClick).click(function () {
      isMobileOpen = !isMobileOpen;
      $(newSelectInput).select2(
        isMobileOpen ? 'open' : 'close'
      );
    });
  };

  /**
   * Update the position of the selector within the DOM, depending on viewport width
   */
  var updateSelectorPosition = function () {
    if ($(window).width() <= navigationMobileBreakpoint) {
      $(newSelectorContainer).prependTo($(mobileNavWrapper));
    } else {
      $(newSelectorContainer).appendTo($(newHeaderPosition));
    }
  }

  /**
   * Prepends flag to innerHTML of a jQuery element
   */
  var prependFlag = function (element, countryCode) {
    element.html(
      '<img src="' + flag(countryCode) + '">' + element.html()
    );
  };

  /**
   * Prepend flag to every option
   */
  var addFlagsToOptions = function () {
    $(newSelectListItem).each(function () {
      var idParts = $(this).attr('id').split('-');
      var countryCode = idParts[idParts.length - 1];
      if ($(this).children('img').length < 1) {
        prependFlag($(this), countryCode);
      }
    });
  };

  /**
   * Listen for the selector to be added to the body via the Geolocation Shopify app
   */
  $(document).ready(function () {
    $('body').on('DOMNodeInserted', function (e) {

      if (updated) return;

      console.log(oldSelectorContainerClass);

      if (e.target.classList.contains(oldSelectorContainerClass)) {

        console.log(e.target.classList);

        console.log(updated);
        
        updated = true;

        console.log(updated);

        /**
         * Duplicate the <select> element into the header
         */
        $(oldSelectorContainer)
          .clone()
          .removeClass(oldSelectorContainerClass)
          .addClass(newSelectorContainerClass)
          .appendTo($(newHeaderPosition));

        /**
         * Add in <optgroup> tags based off schema
         */
        for (var i = optionsSchema.length - 1; i >= 0; i--) {
          var title = optionsSchema[i].title;
          $(newSelectInput).prepend('<optgroup label="' + title + '"></optgroup>');
        }

        /**
         * Add each <option> into the correct <optgroup> based off the schema
         */
        $(newSelectOptions).each(function () {
          var countryCode = $(this).attr('value');
          for (var i = 0; i < optionsSchema.length; i++) {
            var option = optionsSchema[i];
            var countries = option.countries;
            if (countries.includes(countryCode) || countries === '*') {
              $(this).appendTo($(newSelectOptGroups(option.title)));
              break;
            }
          }
        });

        /**
         * Give new input the same value as old input
         */
        $(newSelectInput).val($(oldActiveOption).val());

        /**
         * Initialize slider as Select2 component
         */
        $(newSelectInput).select2();

        /**
         * The dropdown markup only gets added to the DOM after the user clicks
         */
        $(newSelectorContainer).click(function () {
          $(newSelectInputEl).attr('placeholder', 'Search country');
          addFlagsToOptions();
          $(newSelectInputEl).on('input', addFlagsToOptions);
        });

        /**
         * Prepend flag to selected option
         */
        var countryCode = $(oldActiveOption).attr('value');
        prependFlag($(newActiveOption), countryCode);

        /**
         * Update selector position on page load and on window resize
         */
        updateSelectorPosition();
        $(window).resize(updateSelectorPosition);

        /**
         * Initialize event listeners for allowing better mobile clicks
         */
        handleClick();

        /**
         * Update old input and submit form to redirect the user
         */
        $(newSelectInput).change(function () {
          $(oldSelectInput).val($(this).val());
          $(oldSelectorForm).submit();
        });

      }

    });
  });

})(jQuery);